
	import {
		Component,
		Model,
		Prop,
		Vue,
		Watch
	} from "vue-property-decorator";

	@Component({
		name: 'picker-interval',
	})
	export default class PickerDate extends Vue {
		@Model('change') interval!: any;
		@Prop({
			default:true
		}) private canclose:boolean
		@Prop({
			default: '360px'
		}) private width!: string;
		@Prop({
			default: ''
		}) private mintext!: string;
		@Prop({
			default: ''
		}) private maxtext!: string;
		@Prop({
			default: '-'
		}) private spacetext!: string;
		private min = '';
		private max = '';

    @Watch('interval',{deep:true})
    private getval(val){
      if(val&&val.length){
        [this.min,this.max] = val
      }
    }

    private mounted () {
      [this.min,this.max] = this.interval
    }

    private input(e){
      this.$emit('input',[this.min,this.max])
    }

	}
